import { IChartSeries } from '@mais-retorno-front/models/chart-serie';
import { IHttpGet, HTTP_STATUS_CODE } from '../../adapters';
import { ISheetFundQuoteResponse, ISheetFundQuote } from './dto';

export class SheetFundSeriesUseCase {
  constructor(
    private readonly url: string,
    private readonly http: IHttpGet<ISheetFundQuoteResponse>,
    private readonly createNetWorthSerie: (
      assetQuotes: ISheetFundQuoteResponse
    ) => IChartSeries[],
    private readonly createQuotaHolderSerie: (
      assetQuotes: ISheetFundQuoteResponse
    ) => IChartSeries[],
    private readonly createDrawDownSerie: (
      assetQuotes: ISheetFundQuoteResponse[]
    ) => IChartSeries[],
    private readonly createVolatilitySerie: (
      assetQuotes: ISheetFundQuoteResponse[]
    ) => IChartSeries[],
    private readonly createProfitSerie: (
      assetsQuotes: ISheetFundQuoteResponse[]
    ) => IChartSeries[]
  ) {}

  async execute(
    fundSlug: string,
    fundStatus: string,
    serieColor: string
  ): Promise<ISheetFundQuote> {
    if (fundStatus === 'pre-operacional') return;

    const { statusCode, body } = await this.http.get({
      url: `${this.url}/${fundSlug}`,
    });

    if (statusCode !== HTTP_STATUS_CODE.ok) {
      return null;
    }

    const quote = { ...body, color: serieColor };

    const netWorthSeries = this.createNetWorthSerie(quote);
    const quotaHolderSeries = this.createQuotaHolderSerie(quote);
    const profitSeries = this.createProfitSerie([quote]);
    const drawDownSeries = this.createDrawDownSerie([quote]);
    const volatilitySeries = this.createVolatilitySerie([quote]);

    return {
      profitSeries,
      drawDownSeries,
      netWorthSeries,
      quotaHolderSeries,
      volatilitySeries,
    };
  }
}
